/* eslint-disable no-redeclare */
/* global fetch */

const apiBasePath = '/umbraco/surface/WishlistSurface/';

const fetchBaseConfig: RequestInit = {
  credentials: 'same-origin',
  headers: {
    'content-type': 'application/json',
    accept: 'application/json'
  }
};

export const getWishlistViewModel = (wishlistId?: number) => {
  const path = `${apiBasePath}GetWishlistViewModel`;

  return fetch(path, {
    ...fetchBaseConfig,
    method: 'POST',
    body: JSON.stringify({
      wishlistId
    })
  }).then((response) => response.json());
};

export const addWishlistToBasket = (wishlistId: number) => {
  const path = `${apiBasePath}AddWishlistItemsToBasket`;

  return fetch(path, {
    ...fetchBaseConfig,
    method: 'POST',
    body: JSON.stringify({
      wishlistId
    })
  }).then((response) => response.json());
};

export const exportWishList = (wishlistId: number) => {
  const path = `${apiBasePath}ExportWishListAsPdf`;

  const fetchBaseConfig: RequestInit = {
    credentials: 'same-origin',
    headers: {
      'content-type': 'application/json',
      accept: 'application/pdf'
    }
  };

  return fetch(path, {
    method: 'POST',
    ...fetchBaseConfig,
    body: JSON.stringify({ wishlistId: wishlistId })
  }).then((response) => {
    return response;
  });
};

export const getWishlists = () => {
  const path = `${apiBasePath}GetAllWishlists`;

  return fetch(path, fetchBaseConfig).then((response) => response.json());
};

export const createWishlist = (name: string, isDefault: boolean) => {
  const path = `${apiBasePath}CreateWishlist`;

  return fetch(path, {
    ...fetchBaseConfig,
    method: 'POST',
    body: JSON.stringify({
      name,
      defaultStatus: isDefault
    })
  }).then((response) => response.json());
};

export const updateItemQuantity = (
  wishlistId: number,
  catalogueRef: string | null,
  quantity: number
) => {
  const path = `${apiBasePath}UpdateWishlistItemQuantity`;

  return fetch(path, {
    ...fetchBaseConfig,
    method: 'POST',
    body: JSON.stringify({
      wishlistId,
      catalogueRef,
      quantity
    })
  }).then((response) => response.json());
};

export const updateWishlist = (
  wishlistId: number,
  name: string,
  isDefault: boolean
) => {
  const path = `${apiBasePath}UpdateWishlist`;

  return fetch(path, {
    ...fetchBaseConfig,
    method: 'POST',
    body: JSON.stringify({
      wishlistId,
      newWishlistName: name,
      newWishlistDefaultStatus: isDefault
    })
  }).then((response) => response.json());
};

export const shareWishlist = (
  wishlistId: number,
  senderName: string,
  senderEmail: string,
  recipientName: string,
  recipientEmail: string,
  message: string
) => {
  const path = `${apiBasePath}ShareWishlist`;

  console.log('sharing wishlist');

  return fetch(path, {
    ...fetchBaseConfig,
    method: 'POST',
    body: JSON.stringify({
      wishlistId,
      senderName,
      senderEmail,
      recipientName,
      recipientEmail,
      message
    })
  }).then((response) => response.json());
};

export const deleteWishlist = (wishlistId: number) => {
  const path = `${apiBasePath}DeleteWishlist`;

  return fetch(path, {
    ...fetchBaseConfig,
    method: 'POST',
    body: JSON.stringify({
      wishlistId
    })
  }).then((response) => response.json());
};

export const addItemToWishlist = (
  catalogueRef: string | null,
  wishlistId: number,
  quantity: number
) => {
  const path = `${apiBasePath}AddItemToWishlist`;

  const catRef = catalogueRef === 'basket' ? null : catalogueRef;

  return fetch(path, {
    ...fetchBaseConfig,
    method: 'POST',
    body: JSON.stringify({
      catalogueRef: catRef,
      wishlistId,
      quantity
    })
  }).then((response) => response.json());
};

export const addItemToWishlists = (
  catalogueRef: string | null,
  wishlistIds: number[],
  quantity: number
) => {
  const path = `${apiBasePath}AddItemToWishlists`;

  const catRef = catalogueRef === 'basket' ? null : catalogueRef;

  return fetch(path, {
    ...fetchBaseConfig,
    method: 'POST',
    body: JSON.stringify({
      catalogueRef: catRef,
      destinationListIds: wishlistIds,
      quantity
    })
  }).then((response) => response.json());
};

export const createWishlistWithItem = (
  name: string,
  defaultStatus: boolean,
  catalogueRef: string | null,
  quantity: number
) => {
  const path = `${apiBasePath}CreateWishlistWithItem`;

  const catRef = catalogueRef === 'basket' ? null : catalogueRef;

  return fetch(path, {
    ...fetchBaseConfig,
    method: 'POST',
    body: JSON.stringify({
      name,
      defaultStatus,
      catalogueRef: catRef,
      quantity
    })
  }).then((response) => response.json());
};

export const removeItemFromWishlist = (
  wishlistId: number,
  wishlistItemId: number
) => {
  const path = `${apiBasePath}DeleteWishlistItem`;

  return fetch(path, {
    ...fetchBaseConfig,
    method: 'POST',
    body: JSON.stringify({
      wishlistItemId,
      wishlistId
    })
  }).then((response) => response.json());
};

export {
  apiBasePath
  // getItems,
  // clearItems,
  // updateItem,
  // removeItem,
  // addItem,
  // createBasket,
  // uploadFile,
};
